import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * Marca una petición que el `ThrottleInterceptor` NO debe reintentar sola ante un 429.
 *
 * Existe por FGA-61. El interceptor no filtra por método: ante un 429 reenvía lo que
 * sea, POST incluido. Para un endpoint cuyo límite ES la medida de seguridad —el
 * rate-limit de inmovilización, que cuenta por device y por ventana— ese reintento que
 * el operador nunca pidió consume cupo igual, y pone al portal a pelear contra el
 * límite en vez de mostrarlo. La `Idempotency-Key` evita el comando duplicado; no evita
 * el consumo de cupo.
 *
 * Es opt-in por petición y no un cambio global a propósito: en los GET idempotentes el
 * reintento automático sigue siendo lo correcto, y apagarlo para todos cambiaría el
 * comportamiento de pantallas que hoy dependen de él.
 */
export const SKIP_THROTTLE_RETRY = new HttpContextToken<boolean>(() => false);

export function skipThrottleRetry(): HttpContext {
  return new HttpContext().set(SKIP_THROTTLE_RETRY, true);
}
